import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["resources", "namespace"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import i18next from 'i18next';
import ReactPostProcessor from 'i18next-react-postprocessor';
export var NamedLocales = /*#__PURE__*/function (NamedLocales) {
  NamedLocales["Default"] = "en";
  NamedLocales["English"] = "en";
  NamedLocales["German"] = "de";
  NamedLocales["Spanish"] = "es";
  NamedLocales["French"] = "fr";
  NamedLocales["Italian"] = "it";
  NamedLocales["Japanese"] = "ja";
  NamedLocales["Dutch"] = "nl";
  NamedLocales["PortugueseBrazilian"] = "pt-BR";
  NamedLocales["CIMode"] = "cimode";
  return NamedLocales;
}({});

/** @deprecated use the NamedLocales enum */

export var SUPPORTED_LANGUAGES = Array.from(new Set(Object.values(NamedLocales))); // cast down to maintain original types

var defaultOptions = {
  interpolation: {
    escapeValue: false
  },
  supportedLngs: SUPPORTED_LANGUAGES,
  // cast down to match types
  fallbackLng: 'en',
  postProcess: ['reactPostprocessor'],
  initImmediate: false,
  compatibilityJSON: 'v3',
  missingInterpolationHandler: function missingInterpolationHandler(_text, value) {
    return Array.isArray(value) ? value.pop() : '';
  }
};
function initializeInstanceWithDefaults(instance, options) {
  /**
   * This instantiation depends on internals of i18next. Setting initImmediate false above
   * causes i18next to fully initialize almost immediately. This allows us to 'cheat' as a
   * library and completely ignore the promise that `init` will generate below, resulting
   * in no contractual changes.
   *
   * In the event of a bug related to initialization, validate that the current mainline of
   * i18next has not drifted too far from:
   * https://github.com/i18next/i18next/blob/a68ffca1d1497e63df08d5015f2c12d142a2c699/src/i18next.js#L193-L197
   *
   * We're specifically interested in the logic on 194.
   */
  instance.use(new ReactPostProcessor({
    prefix: '{<',
    suffix: '>}'
  })).init(_objectSpread(_objectSpread({}, defaultOptions), options));
  return instance;
}
function checkInstanceAndSetCurrentLanguage(language) {
  if (i18next.isInitialized) {
    throw new Error('Translations are already initialized. Re-initializing would reset existing translations.');
  }
  globallyConfigureCurrentLanguage(language);
}

/**
 * Should only be used in hosting applications.
 *
 * This initializes the application's default instance of i18next, and sets up the global
 * language to be consumed by libraries in their instances.
 */
export function init(options) {
  checkInstanceAndSetCurrentLanguage(options.lng);
  return initializeInstanceWithDefaults(i18next, options);
}

/**
 * Should only be used in hosting applications.
 *
 * This initializes the application's default instance of i18next, and sets up the global
 * language to be consumed by libraries in their instances.
 *
 * If your application can support it, this form of initialization is the more preferred
 * way to initialize the library.
 */
export function initAsync(options) {
  checkInstanceAndSetCurrentLanguage(options.lng);
  return i18next.use(new ReactPostProcessor({
    prefix: '{<',
    suffix: '>}'
  })).init(_objectSpread(_objectSpread({}, defaultOptions), options));
}
export var t = function t() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }
  return i18next.t.apply(i18next, params);
};
export var withPrefix = function withPrefix(prefix) {
  var joinBy = /\.|:|\//.test(prefix[prefix.length - 1]) ? '' : '.';
  return function () {
    for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      params[_key2] = arguments[_key2];
    }
    params[0] = prefix + joinBy + params[0];
    return t.apply(t, params);
  };
};
export var addResourceBundle = function addResourceBundle() {
  for (var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    params[_key3] = arguments[_key3];
  }
  return i18next.addResourceBundle.apply(i18next, params);
};
export function getLanguage() {
  var _i18next$languages$, _i18next$languages;
  var language = (_i18next$languages$ = (_i18next$languages = i18next.languages) === null || _i18next$languages === void 0 ? void 0 : _i18next$languages[0]) !== null && _i18next$languages$ !== void 0 ? _i18next$languages$ : getGloballyConfiguredLanguage();
  if (language) {
    return language;
  }
  console.warn('[@citrite/translate] No language configured. Defaulting to English.');
  return 'en';
}
var globalKey = '__citrix_translate_internal_current_language__';
function globallyConfigureCurrentLanguage(language) {
  var globalContainer = getGlobalContainer();
  if (globalContainer && !getGloballyConfiguredLanguage()) {
    globalContainer[globalKey] = language;
  }
}
function getGloballyConfiguredLanguage() {
  var globalContainer = getGlobalContainer();
  if (globalContainer) {
    return globalContainer[globalKey];
  }
  return undefined;
}
function getGlobalContainer() {
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  return undefined;
}
/**
 * Create an isolated translator instance with the same default behavior as the primary instance.
 * This is not a clone of the primary instance, e.g. loaded resources will not carry over.
 * Intended for usage by library packages with their own scoped translations synchronously available,
 * where a language may be set on the instance later.
 *
 * If the language is not set, it defaults to a language set by the host application, or logs a warning
 * and defaults to English.
 */
export function createScopedInstance(_ref) {
  var resources = _ref.resources,
    namespace = _ref.namespace,
    options = _objectWithoutProperties(_ref, _excluded);
  var reducedResources = resources === null || resources === void 0 ? void 0 : resources.reduce(function (accum, _ref2) {
    var key = _ref2.key,
      content = _ref2.content;
    accum[key] = _defineProperty({}, namespace, content);
    return accum;
  }, {});
  var scopedInstance = initializeInstanceWithDefaults(i18next.createInstance(), _objectSpread({
    initImmediate: true,
    compatibilityJSON: 'v3',
    resources: reducedResources,
    ns: namespace
  }, options));
  var i18nextT = scopedInstance.t.bind(scopedInstance);
  scopedInstance.t = function () {
    var _options$lng;
    // This allows a scoped instance to consume the global language from the
    // host application without needing it explicitly passed into each consumer
    var targetLng = (_options$lng = options.lng) !== null && _options$lng !== void 0 ? _options$lng : getLanguage();
    if (scopedInstance.language !== targetLng) {
      scopedInstance.changeLanguage(targetLng);
    }
    return i18nextT.apply(void 0, arguments);
  };
  return scopedInstance;
}